// Get dropdown list cells based on column name
export function getSelectList(key, data) {
  const statusTypes = [];
  statusTypes.push({ name: "All", value: "__ALL__" });

  // Get unique values from the column
  const columnValues = data.tableArray.map((row) => row[key]);
  const uniqueValues = [...new Set(columnValues)];

  uniqueValues.forEach((value) => {
    // Handle different value types with appropriate display names
    let displayName;
    if (value === "" || value == null) {
      displayName = "(Empty)";
    } else {
      displayName = value;
    }
    statusTypes.push({ name: displayName, value });
  });

  return statusTypes;
}

export function updateFilters(column, value, data) {
  // Remove any occurance of this column
  const r = [...data.filters].filter((s) => s.column !== column);
  // Push column to filter only if entered data is not null
  if (value !== "") {
    r.push({
      column: column,
      text: value,
      isPartialMatch: true, // Flag for partial matching (description search)
    });
  }
  data.setFilters(r);
}

export function updateMultipleFilters(
  column,
  selectedValues,
  data,
  options = []
) {
  // Remove any occurance of this column
  const r = [...data.filters].filter((s) => s.column !== column);

  // Find the "All" option
  const allOption = options.find((opt) => opt.name === "All");

  // Create separate filter objects for each selected value (OR logic)
  if (Array.isArray(selectedValues)) {
    selectedValues.forEach((selectedValue) => {
      // Skip "All" option
      if (!allOption || selectedValue !== allOption.value) {
        r.push({
          column: column,
          text: selectedValue,
        });
      }
    });
  }

  data.setFilters(r);
}

export function updateMinMaxFilters(column, value, minOrMax, data) {
  // Remove any occurance of this column
  const temp = [...data.filters].filter(
    (s) => s.column !== column || s.minOrMax !== minOrMax
  );
  // Push column to filter only if entered data is not null
  if (value !== "") {
    temp.push({ column: column, text: value, minOrMax: minOrMax });
  }
  data.setFilters(temp);
}
